
define([
    "csi/config",
	"dojo/_base/declare",
	"SiteAdmin/AttributeMap/AttributeMapTable"
], function(config,declare,AttributeMapTable) {

	var SETTINGS_URL = "centric://REFLECTION/INSTANCE/CostMaterialConfig/Settings";
	var SETUP_SETTINGS_URL = "centric://REFLECTION/INSTANCE/CostMaterialConfig/SetupSettings";
	var MAP_SETTING_ID = "PartMaterialAttributeMap";
	var MAP_ENTRY_NODE_TYPE = "_PartMaterialAttributeMapEntry_";
	var DEST_ATTR_ID_ATTR = "PartMaterialAttributeId";
	var SOURCE_CLASS_NAME = "CostMaterial";

	var SOURCE_ATTR_NAMES = [
	        "CostColor",
            "CostMaterialName",
            "CostProduct",
            "CostProductSize",
            "CostSizeSpec",
            "CostQuote",
            "Description",
            "DutyTotal",
            "FreightTotal",
            "MaterialFOBCost",
            "MaterialTotal",
            "Node Name",
            "Quantity",
            "QuantityUsage",
            "UnitPrice",
            "UsageFactorPct"
        ];

	var DEST_CLASS_NAMES = ["PartMaterial"];
	var DEST_ATTR_NAMES = [
           "Actual",
           "BOMLineQuote",
           "Comment",
           "CommonColor",
           "CommonSize",
           "CommonSizeSpec",
           "ID",
           "LossPct",
           "MainMaterial",
           "Node Name",
           "QtyDefault",
           "SourcingModel",
           "UnitPriceAct",
           "UOM"
        ];

	AttributeMapTable.watchValueDropDown(MAP_ENTRY_NODE_TYPE, DEST_ATTR_ID_ATTR);

	 var _PartMaterialAttributeMapTable = declare(AttributeMapTable, {
		settingsUrl: SETTINGS_URL,
		setupSettingsUrl: SETUP_SETTINGS_URL,
		mapSettingId: MAP_SETTING_ID,
		mapEntryNodeType: MAP_ENTRY_NODE_TYPE,
		destAttrIdAttr: DEST_ATTR_ID_ATTR,
		currentExceptionReportKey: config.getClassSetting("CostMaterial","ExceptionReportKey"),
		sourceClassName: SOURCE_CLASS_NAME,
		sourceAttributeNames: SOURCE_ATTR_NAMES
	});

	 _PartMaterialAttributeMapTable.SOURCE_CLASS_NAME = SOURCE_CLASS_NAME;
	 _PartMaterialAttributeMapTable.SOURCE_ATTR_NAMES = SOURCE_ATTR_NAMES;
	 _PartMaterialAttributeMapTable.DEST_CLASS_NAMES = DEST_CLASS_NAMES;
	 _PartMaterialAttributeMapTable.DEST_ATTR_NAMES = DEST_ATTR_NAMES;

	return _PartMaterialAttributeMapTable;
});